import { render, staticRenderFns } from "./VehicleDeclaration.vue?vue&type=template&id=02547820&"
import script from "./VehicleDeclaration.vue?vue&type=script&lang=js&"
export * from "./VehicleDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDeclaration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports